import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
    App,
    Home,
    About,
    HowItWorks,
    FAQ,
    Media,
    Fund,
    FundRedirect,
    List,
    Compare,
    Family,
    NotFound,
    Legal,
    Companies,
    IndexFunds,
    TargetDateSeries,
    Toolkit,
    Petitions,
  } from 'containers'

export default (store) => {
  return (
    <Route path="/" component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Routes */ }
      <Route path="/funds/:fundId/:investmentVehicleId/:ticker" component={FundRedirect}/>
      <Route path="/funds/:fundId/:investmentVehicleId" component={FundRedirect}/>
      <Route path="/fund/:name/:ticker/profile/:fundId/:investmentVehicleId" component={Fund}/>
      <Route path="/funds" component={List}/>
      <Route path="/compare" component={Compare}/>
      <Route path="/families" component={Family}/>
      <Route path="/about" component={About}/>
      <Route path="/how-it-works" component={HowItWorks}/>
      <Route path="/faq" component={FAQ}/>
      <Route path="/toolkit" component={Toolkit}/>
      <Route path="/media" component={Media}/>
      <Route path="/legal" component={Legal}/>
      <Route path="/companies" component={Companies}/>
      <Route path="/index-funds" component={List}/>
      <Route path="/target-date-funds" component={List}/>
      <Route path="/target-date-funds/:strategyName" component={List}/>
      <Route path="/petitions" component={Petitions}/>
      <Route path="/petitions/:assetManager" component={Petitions}/>

      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};
